import { DevicePreviewEnum, type DTFile, type FieldADTValue, type FieldProtocol, type FileValue } from '@lighthouse/core'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import type { EnableActionsParams } from '../../types'
import { FileListPreviewer } from '../FileUploader/FileListPreviewer'
import type { UseUploadFileSParameter } from '../UploadManage'

const SCxDiv = styled.div`
    width: 100%;
`

interface VideoValueEditorProps {
    recordId: string
    field: FieldProtocol
    data?: FileValue
    enableFileDownload?: boolean
    uploadyOptions: Pick<UseUploadFileSParameter, 'info' | 'options'>
    onCellChange?: (recordId: string, data: FieldADTValue) => Promise<boolean>
}

export const VideoValueEditor: React.FC<VideoValueEditorProps> = ({
    recordId,
    data,
    field,
    uploadyOptions,
    enableFileDownload,
    onCellChange
}) => {
    const enableItemActions: EnableActionsParams = { canDownload: enableFileDownload, canPreview: true, canDelete: true }

    const handleChange = useCallback(
        (data: DTFile[]) => {
            onCellChange?.(recordId, { ...field, type: 'video', value: data })
        },
        [field, onCellChange, recordId]
    )

    return (
        <SCxDiv>
            <FileListPreviewer
                previewType={DevicePreviewEnum.DESKTOP}
                accept="video/*"
                isPexels={false}
                isUsedLink={false}
                uploadyOptions={uploadyOptions}
                enableItemActions={enableItemActions}
                autoOpenWhenEmpty
                onChange={handleChange}
                files={data || []}
            />
        </SCxDiv>
    )
}
